import { ref } from "vue";
import axiosInstance from "../config/axiosConfig.js";

class RegionService {
  constructor() {
    this.message = ref("");
    this.regionsData = ref([]);
  }

  async getRegions() {
    try {
      const response = await axiosInstance.get(`/passenger/regions`);
      this.regionsData.value = response.data.data ?? [];
      return true;
    } catch (e) {
      console.log("Error occurred while getting Passenger Regions:", e);
      return false;
    }
  }
}

export default RegionService;
